export const DL_CAMPAIGN_URL = 'https://share.mobo.com.br/campaignId?%2FcampaignId=';
export const DL_DELIVERY_URL = 'https://share.mobo.com.br/deliveryCampaignId?%2FdeliveryCampaignId=';
export const DL_COMMERCIAL_PLACE_URL = 'https://share.mobo.com.br/commercialPlaceIdArgument?%2FcommercialPlaceIdArgument=';
export const APP_STORE_URL = 'https://apps.apple.com/br/app/mobo-cupons-para-restaurantes/id454983754';
export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=br.com.mobo.cupons&hl=pt_BR';
export const DESKTOP_FALLBACK_URL = 'https://mobo.com.br/baixe-o-app';
